import EFOcats_event from '../../../core/v1/event/efocats_event.js';
import EFOcats_event_retro_input from './efocats_event_retro_input';
import EFOcats_event_retro_date from './efocats_event_retro_date';
import EFOcats_event_retro_branch from './efocats_event_retro_branch';
import EFOcats_event_retro_postno from './efocats_event_retro_postno';
/**
 * レトロイベントクラス
 */
export default class EFOcats_event_retro extends EFOcats_event {
  constructor() {
    super();
    // イベント追加
    this.input = new EFOcats_event_retro_input();
    this.date = new EFOcats_event_retro_date();
    this.branch = new EFOcats_event_retro_branch();
    this.postno = new EFOcats_event_retro_postno();
  }
}
